import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GrowlComponent } from './growl.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: GrowlComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class GrowlRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/view/growl/growl-routing.module.ts